<template>
    <div id="calendar-confirmed" class="calendar-confirmed">
        <h2><span>Confirmed</span></h2>
        <CalendarListing 
            :itemsByDate="confirmedByDate"
            :timezone="timezone"
            :me="me"
            @modal="doModal"
        />

    </div>
</template>

<script>
/** Iterate through the list inserting LOCAL day boundaries as required.
 */
import CalendarListing from "@/views/calendar/CalendarListing";
import {groupByDateRange} from '@/utils/Sort';


export default {
    name: "CalendarConfirmed",
    props: {
        items: {
            type: Array,
            required: true,
        },
        itemsByDate: {
            type: Object,
            required: true,
        },
        privatesByDate: {
            type: Object,
            required: true,
        },
        busySlotIds: {
            type: Set,
            required: true,
        },
        itineraryByDate: {
            type: Object,
            required: true,
        },
        pageDate: {
            type: String,
            required: true,
        },
        eventDates: {
            type: Array,
            required: true,
        },
        activeDates: {
            type: Array,
            required: true,
        },
        itineraryDates: {
            type: Array,
            required: true,
        },
        event: {
            type: Object,
            required: true,
        },
        timezone: {
            type: String,
            required: true,
        },
        filters: {
            type: Object,
            required: true,
        },
        toggles: {
            type: Object,
            required: true,
        },
        slots: {
            type: Array,
            required: false,
        },
        tracks: {
            type: Array,
            required: false,
        },
        me: {
            type: Object,
            required: false,
        }
    },
    components: {
        CalendarListing,
    },
    computed: {
        confirmedByDate() {
            return groupByDateRange(this.filters.confirmed, 'startObj', 'endObj', this.timezone);
        },
    },
    methods: {
        doModal(item) {
            this.$emit('modal', {
                item: item,
                items: this.items
            });
        },

    }
}
</script>

<style>

</style>